export const DELETION_STATUS_REFRESH = 'repcheck:deletion-status-refresh';
